<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="subBlockContainer">
  <child-header [title]="title" (closeEvent)="close()"></child-header>
  <div #ParentWrapper class="subBlockContent">
    <div class="title-wrapper">
        <div class="page-title-wrapper row">
          <div class="title blade-title-font col-9">
            {{opportunityID}}
            <div class="pop-up-black-text">
              {{title}}
            </div>
          </div>
          <div class="col-2 small-logo">
            <img [src]="programLogo" />
          </div>
          <!-- <div class="col-1">
            <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
          </div> -->
        </div>
        <!-- <div class="row filter-wrapper">
          <div class="col-md-10 long-description">
            <small style="font-size:9px;"></small>
          </div>
          <div class="col-md-2 small-logo" style="padding-right: 20px">
            <img src="https://portal.dickerdata.com.au/resourcefiles/autodesk.png" />
          </div>
        </div> -->
    </div>
    
    <div *ngIf="loadContent" class="item-title-wrapper">
      <div class="wrapper center-block">
        <ng-container *ngFor="let message of messages">
          <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
            <div class="panel panel-default">
              <div class="panel-heading active" role="tab" id="headingOne">
                <h4 class="panel-title">
                  <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne"
                    aria-expanded="false" aria-controls="collapseOne">
                    <span class="highlight-text">OPPORTUNITY DETAILS</span>
                    <span class="panel-subtitle" id="panelsubtitle">
                      <label class="lable-title">NAME:&nbsp;</label>
                      <span class="lable-content">{{ message?.accounts?.end_customer?.account?.name }}</span>
                      <label class="lable-title">CONTRACT NO:&nbsp;</label>
                      <span class="lable-content">{{ contractNum }}</span>
                      <label class="lable-title">| CSN:&nbsp;</label>
                      <span class="lable-content">{{ message?.accounts?.end_customer?.account?.csn }}</span>
                      <label class="lable-title">| STATUS:&nbsp;</label>
                      <span class="lable-content">{{ message?.status }}</span>
                      <span class="triangle-down"></span>
                    </span>
                  </a>
                </h4>
                <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                  <div class="panel-body">
                    <div class="panel-content">
                      <div class="row">
                        <div class="col-sm">
                          <label class="lable-title">NAME</label>
                          <p class="paragraph-text">
                            {{ message?.accounts?.end_customer?.account?.name }}</p>
                        </div>
                        <div class="col-sm">
                          <label class="lable-title">CONTACT NAME</label>
                          <p class="paragraph-text">
                            {{ message?.accounts?.end_customer?.contract_manager?.first }}
                            {{ message?.accounts?.end_customer?.contract_manager?.last }}
                          </p>
                        </div>
                        <div class="col-sm">
                          <label class="lable-title">STATUS</label>
                          <p class="paragraph-text">{{ message?.status }}</p>
                        </div>
                      </div>
                      <div class="row">
                        <!-- <div class="col-sm">
                          <label class="lable-title">TENANT ID / CONTRACT</label>
                          <p class="paragraph-text">
                            {{ message?.accounts?.end_customer?.account?.csn }}</p>
                        </div> -->
                        <div class="col-sm">
                          <label class="lable-title">CSN</label>
                          <p class="paragraph-text">
                            {{ message?.accounts?.end_customer?.account?.csn }}</p>
                        </div>
                        <div class="col-sm">
                          <label class="lable-title">TENANT DESCRIPTION</label>
                          <p class="paragraph-text">
                            {{ message?.accounts?.end_customer?.account?.name }}</p>
                        </div>
                        <div class="col-sm">
                          <label class="lable-title">PHONE</label>
                          <p class="paragraph-text"></p>
                        </div>
                        <!-- <div class="col-sm">
                              <label class="lable-title">NEXT BILLING DATE</label>
                              <p class="paragraph-text"></p>
                            </div> -->
                      </div>
                      <div class="row">
                        <div class="col-sm">
                          <label class="lable-title">OPPORTUNITY ID</label>
                          <p class="paragraph-text">
                            {{ opportunityID }}</p>
                        </div>
                        <div class="col-sm">
                          <label class="lable-title">EMAIL</label>
                          <p class="paragraph-text">
                            {{ message?.accounts.end_customer?.contract_manager?.email }}
                          </p>
                        </div>
                        <div class="col-sm">
                          <label class="lable-title">ADDRESS</label>
                          <p class="paragraph-text">
                            {{ message?.accounts?.end_customer?.account?.address_line_1 }}
                            {{ message?.accounts?.end_customer?.account?.address_line_2 }}
                            {{ message?.accounts?.end_customer?.account?.address_line_3 }}
                          </p>
                          <p class="paragraph-text">
                            {{ message?.accounts?.end_customer?.account?.city}},
                            {{ message?.accounts?.end_customer?.account?.state }}
                            {{ message?.accounts?.end_customer?.account?.postal }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm">
                          <label class="lable-title">CONTRACT NO</label>
                          <p class="paragraph-text">
                            {{ contractNum }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div style="margin-top: 20px;" class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
          <div class="panel panel-default">
            <div class="panel-heading active" role="tab" id="headingOne">
              <div class="panel-body">
                <div class="panel-content">
                  <div class="mTable-header">
                    <div class="filter-wrapper">
                      <div class="searchInputGroup push-left">
                        <div class="searchIcon">
                          <img src="../../images/new_ui/filter.png">
                        </div>
                        <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="searchField"
                          (ngModelChange)="onChange()">
                      </div>
                    </div>
                  </div>
                  <div class="mTable">
                    <table matSort (matSortChange)="sortData($event)" class="white" style="min-width: 100%">
                      <thead>
                        <tr class="row">
                          <th class="col-2" mat-sort-header="serialNum">Serial Num</th>
                          <th class="col-5" mat-sort-header="description">Description</th>
                          <th class="col-1" mat-sort-header="depolyment">Deployment</th>
                          <th class="col-1" mat-sort-header="rrp">RRP</th>
                          <th class="col-2" mat-sort-header="unitPrice" style="max-width:120px;">Unit Price</th>
                          <th class="col-1" mat-sort-header="qty">QTY</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let item of sortedData | TableFilterMultiple:['serial_number', 'sku_description', 
                        'deployment', 'rrp_price', 'unit_price', 'quantity'] : searchField">
                          <tr class="row">
                            <td class="col-2">{{item?.serial_number}}</td>
                            <td class="col-5">{{item?.sku_description}}</td>
                            <td class="col-1">{{item?.deployment}}</td>
                            <td class="col-1 align-right" style="padding-right: 50px">
                              {{item?.rrp_price | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                            <td class="col-2 align-right" style="max-width:120px; padding-right: 50px">
                              {{item?.unit_price| currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                            <td class="col-1 align-right" style="padding-right: 50px">{{item?.quantity}}</td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                  <div class="row position-relative">
                    <ng-container *ngFor="let message of messages">
                      <div class="col align-center" *ngIf="message.status === 'Open'|| message.status ==='Ready for Order'">
                        <div class="button-center">
                          <button class="button button-red button-medium" style="margin: 0 20px;"
                            (click)="getRenewList();">Renew</button>
                          <button class="button button-red button-medium" style="margin: 0 20px;" [disabled]="disableTermSwitch"
                            (click)="confirmSwitch();">Term Switch to {{ switchTo }}</button>
                          <!-- Have the same button exist with different functions if a quote already exists -->
                          <button *ngIf="shouldCreateNewQuote" class="button button-red button-medium" style="margin: 0 20px;"
                            [disabled]="disableTermSwitch" (click)="generateQuote();">Download Quote</button>
                          <button *ngIf="!shouldCreateNewQuote" class="button button-red button-medium" style="margin: 0 20px;"
                            [disabled]="disableTermSwitch" (click)="downloadQuote();">Download Quote</button>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loading-screen *ngIf="!loadContent" [isRenewDetail]="true" [showBlurTable]="true"></loading-screen>
    <div class="inner-subBlock-wrapper" *ngIf="loadContent">

      
    </div>
  </div>
</div>
<!-- Modal -->
<div class="modal fade" id="addNewSubscriptionModdal" tabindex="-1" role="dialog" aria-labelledby="modalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="title popup-title-font" id="modalLabel">Renew</h5>
        <button type="button button-red button-large" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row filter-wrapper filter-wrapper-margin">
          <mat-form-field>
            <input matInput type="text" class="poReference" [(ngModel)]="poReference" placeholder="PO REFERENCE" />
          </mat-form-field>
        </div>
        <loading-icon [currentLoadingStatus]="renewloadingStatus" *ngIf="renewloadingStatus === true">
        </loading-icon>
        <div class="col filter-wrapper" *ngIf="transactOpportunity?.out?.sales_order_number">
          <label class="lable-title">Your order has processed successfully.<br> Order Reference:
            <span class="highlight-text">{{transactOpportunity?.out?.sales_order_number}}</span>
          </label>
        </div>
        <div class="col align-center" *ngIf="!transactOpportunity?.out?.sales_order_number">
          <button *ngIf="renewloadingStatus === false" class="button button-red button-large btn-long"
            (click)="renew(poReference)">Renew</button>
        </div>
      </div>
    </div>
  </div>
  <modal-popup></modal-popup>
</div>
<!-- <router-outlet></router-outlet> -->
